import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRoute } from '@angular/router';
import {OnInit} from '@angular/core';
import { DataService } from '../services/data.service';
import {ProductionListComponent} from './production-list/production-list.component';
import {StageConfigComponent} from './stage-config/stage-config.component';
import {JobDetailsComponent} from './job-details/job-details.component';
import {ProductionOutputComponent} from './production-output/production-output.component';
import { ProcessStagesComponent } from './process-stages/process-stages.component';
import { ReportComponent } from './report/report.component';
import {RejectionsReasonsConfigComponent } from './rejections-reasons-config/rejections-reasons-config.component'
import { SettingsComponent } from './settings/settings.component';
import { AuthGuardService } from '../services/auth-guard.service';
import {ExpenseConfigComponent} from './expense-config/expense-config.component';
import { EnterExpenseComponent } from './enter-expense/enter-expense.component';




const routes: Routes = [
   // { path: 'ProductionList', component: ProductionListComponent, canActivate:[AuthGuardService] },
    { path: 'ProductionList', component: ProductionListComponent, canActivate:[AuthGuardService] , data: { viewOption: 'ProductionList' } },
    { path: 'Projects', component: ProductionListComponent, data: { viewOption: 'Projects' } },
    { path: 'StageConfig', component: StageConfigComponent },
    { path: 'JobDetail', component: JobDetailsComponent },
    { path: 'ProductionOutput', component: ProductionOutputComponent },
    { path: 'ProcessStages', component: ProcessStagesComponent },
    { path: 'RejectionReasons', component: RejectionsReasonsConfigComponent },
    { path: 'ProductionSettings', component: SettingsComponent },
    { path: 'ProductionReports', component: ReportComponent },
    { path: 'ExpenseConfig', component: ExpenseConfigComponent },
    { path: 'EnterExpenseComponent', component: EnterExpenseComponent },

  ];
 
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductionRoutingModule implements OnInit{ 
  constructor(
    public dataservice: DataService,
    private route: ActivatedRoute
  ) {}

  viewOption : any;
  ngOnInit() {
    debugger
    this.viewOption = this.route.snapshot.data.viewOption;
  }
}
